export default __webpack_public_path__ + "static/media/scroll-placerholder.f14ee6a6.png";